<div class="card mb-4">
    <div class="list-group list-group-flush">
        <a class="nocolor list-group-item list-group-item-action" routerLink="/user/profile" routerLinkActive="active">{{ 'user.YOUR_PROFILE' | translate }}</a>
        <a class="nocolor list-group-item list-group-item-action" routerLink="/user/password" routerLinkActive="active">{{ 'user.PASSWORD' | translate }}</a>
    </div>
</div>